import {
  type FC,
  type PropsWithChildren,
  type ReactNode,
  useEffect,
  useState,
} from 'react';

import type {ContainerModule} from 'inversify';

import {useInjectionContext} from '../hooks/useInjectionContext';
import {ROOT_CONTAINER_KEY} from '../utils';

type Props = PropsWithChildren & {
  containerKey?: string;
  extensions: ContainerModule[];
  renderLoader?: () => ReactNode;
};

export const ContainerExtend: FC<Props> = ({
  children,
  containerKey = ROOT_CONTAINER_KEY,
  extensions,
  renderLoader = () => null,
}) => {
  const context = useInjectionContext();
  const container = context.get(containerKey);
  const [isLoaded, setIsLoaded] = useState(false);

  if (!container) {
    throw new Error(`Container with key ${containerKey} is not found`);
  }

  useEffect(() => {
    container.loadSync(...extensions);

    setIsLoaded(true);

    return () => container.unloadSync(...extensions);
  }, [container, extensions]);

  return isLoaded ? <>{children}</> : renderLoader();
};
